import React, { useId } from 'react';
import { Check } from 'lucide-react';
interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label: React.ReactNode;
  description?: React.ReactNode;
}
/**
 * Standardized Maybank checkbox.
 * - Visible 2px border with Maybank yellow checked state and black tick.
 * - 44x44 touch target via padded label.
 * - Native input is positioned underneath for full a11y/keyboard support.
 */
export function Checkbox({
  label,
  description,
  className = '',
  id,
  checked,
  onChange,
  disabled,
  ...props
}: CheckboxProps) {
  const reactId = useId();
  const fieldId = id || props.name || `chk-${reactId}`;
  return <label htmlFor={fieldId} className={`group flex items-start gap-3 cursor-pointer select-none py-1 ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${className}`} data-id="element-948">
      <span className="relative flex-shrink-0 inline-flex items-center justify-center mt-0.5" data-id="element-949">
        <input id={fieldId} type="checkbox" checked={checked} onChange={onChange} disabled={disabled} className="peer sr-only" {...props} data-id="element-950" />
        <span aria-hidden="true" className="w-5 h-5 rounded border-2 border-gray-700 bg-white flex items-center justify-center transition-colors
            peer-checked:bg-[#FFCC00] peer-checked:border-black
            peer-focus-visible:ring-2 peer-focus-visible:ring-black peer-focus-visible:ring-offset-2
            group-hover:border-black" data-id="element-951">
          <Check className={`w-3.5 h-3.5 text-black transition-opacity ${checked ? 'opacity-100' : 'opacity-0'}`} strokeWidth={3} data-id="element-952" />
        </span>
      </span>
      <span className="min-w-0 text-sm leading-relaxed" data-id="element-953">
        <span className="text-gray-900" data-id="element-954">{label}</span>
        {description && <span className="block text-gray-600 text-xs mt-0.5" data-id="element-955">
            {description}
          </span>}
      </span>
    </label>;
}